export class Account{
    id: number;
    fullName : string;
    avartar : string;
    address: string;
    gender : number;
    email : string;
    birthDay : string;
    groupId : number; 
    phoneNumber : string;
    userName : string;
    passwordHash : string;
    constructor(){
        this.id = 0;
    }
}
